export default __webpack_public_path__ + "static/media/pk.765da9fe.svg";